// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607310317/js/" + chunkId + "." + {"44":"600c3c84","225":"6c8f4cc4","481":"089c9649","486":"6ed5e478","770":"b391db5a"}[chunkId] + ".0.19007517345001046.chunk.js";
};